<template>
	<div class="page-form-cont detail-cont">
		<Card class="noCardHeader">
			<div class="module-cont">
				<div class="flex-row">
					<el-descriptions :column="6" size="small" labelStyle="width: auto;">
						<template slot="title">
							<div>
								联系人： {{ orderInfo.vcontactName }}
								{{ orderInfo.vcontactTelephone }}
							</div>
						</template>

						<el-descriptions-item label="审核状态">
							{{ orderInfo.iauditStatusName }}
						</el-descriptions-item>
						<el-descriptions-item label="维修状态">
							{{ orderInfo.irepairStatusName }}
						</el-descriptions-item>
						<el-descriptions-item label="取消状态">
							{{
								orderInfo.isCancel == "1"
									? "已取消"
									: orderInfo.isCancel == "0"
									? "未取消"
									: ""
							}}
						</el-descriptions-item>
					</el-descriptions>
					<div
						v-if="$init.hasPower(`/overhaul/overhaulList##WXSH`)"
						v-show="orderInfo.iauditStatus == '1' && orderInfo.isCancel != '1'"
					>
						<el-button type="primary" size="small" @click="openTrigger"
							>审核</el-button
						>
					</div>
				</div>
			</div>

			<div class="module-cont">
				<workFlow :list="flowNodeList" />
			</div>
			<div class="module">
				<div class="module-title">
					<div class="el-descriptions__title">产品信息</div>
				</div>
			</div>
			<div class="module-cont">
				<el-descriptions :column="3">
					<el-descriptions-item label="产品名称">
						{{ productInfo.proName }}
					</el-descriptions-item>
					<el-descriptions-item label="限额">
						{{ $utils.formatMoneyThousand({ value: productInfo.guaLimt }) }}
					</el-descriptions-item>
				</el-descriptions>
				<el-descriptions :column="1">
					<el-descriptions-item label="限额说明">
						{{ productInfo.instSummary }}
					</el-descriptions-item>
				</el-descriptions>
			</div>
			<div class="module">
				<div class="module-title">
					<div class="el-descriptions__title">基础信息</div>
				</div>
			</div>
			<div class="module-cont">
				<el-descriptions :column="3">
					<el-descriptions-item label="渠道类型">
						{{ orderInfo.vsourceTypeName }}
					</el-descriptions-item>
					<el-descriptions-item label="维修单号">
						{{ orderInfo.vrepairNo }}
					</el-descriptions-item>
					<el-descriptions-item label="创建日期">
						{{ $utils.timeFormat(orderInfo.dcreatetime) }}
					</el-descriptions-item>
					<el-descriptions-item label="维修大类">
						{{ orderInfo.vrepairTypeName }}
					</el-descriptions-item>
					<el-descriptions-item label="维修小类">
						{{ orderInfo.vrepairSubTypeName }}
					</el-descriptions-item>
					<el-descriptions-item label="预约上门时间">
						{{ orderInfo.vreserveVisitTime }}
					</el-descriptions-item>

					<el-descriptions-item label="故障类型">
						{{ orderInfo.vmalfunctionTypeName }}
					</el-descriptions-item>
					<el-descriptions-item label="产品品牌">
						{{ orderInfo.vproductBrand }}
					</el-descriptions-item>
					<el-descriptions-item label="产品年限">
						{{ orderInfo.vproductLife }}
					</el-descriptions-item>
					<el-descriptions-item label="产品型号">
						{{ orderInfo.vproductModel }}
					</el-descriptions-item>
					<el-descriptions-item label="回传维修审核结果">
						{{ $constants.getLabel("backIsOr", orderInfo.ibackRepairAudit) }}
					</el-descriptions-item>
					<el-descriptions-item label="回传上门维修结果">
						{{ $constants.getLabel("backIsOr", orderInfo.ibackRepairVisit) }}
					</el-descriptions-item>
					<el-descriptions-item label="回传维修服务结果">
						{{ $constants.getLabel("backIsOr", orderInfo.ibackRepairResult) }}
					</el-descriptions-item>
					<el-descriptions-item label="保单办理时间">
						{{ orderInfo.policyCreateDate }}
					</el-descriptions-item>
					<el-descriptions-item label="保单生效时间">
						{{ orderInfo.policyEffectiveDate }}
					</el-descriptions-item>
					<el-descriptions-item label="保单终止时间">
						{{ orderInfo.policyEndDate }}
					</el-descriptions-item>
					<el-descriptions-item label="上门维修地址">
						{{ orderInfo.visitRepairAddress }}
					</el-descriptions-item>
				</el-descriptions>

				<el-descriptions>
					<el-descriptions-item label="故障图片">
						<div v-if="malFunctionImages.length > 0">
							<ul class="el-upload-list el-upload-list--picture-card">
								<li
									tabindex="0"
									class="el-upload-list__item is-ready"
									v-for="(item, index) in malFunctionImages"
									:key="index"
								>
									<el-image
										:src="`${item}`"
										alt=""
										class="el-upload-list__item-thumbnail"
										:preview-src-list="malFunctionImages"
									/>
								</li>
							</ul>
						</div>
					</el-descriptions-item>
				</el-descriptions>
				<el-descriptions>
					<el-descriptions-item label="维修备注">
						{{ orderInfo.vremark }}
					</el-descriptions-item>
				</el-descriptions>
			</div>

			<div class="module" v-if="hisRepairList.length > 0">
				<div class="module-title">
					<div class="el-descriptions__title">维修记录</div>
				</div>
			</div>
			<div class="module-cont" v-if="hisRepairList.length > 0">
				<el-collapse accordion @change="handleCollapseChange">
					<el-collapse-item
						v-for="(item, index) in hisRepairList"
						:key="index"
						:name="item.pkFacilityRepairOrderId"
					>
						<template slot="title">
							<div class="descriptions-div">
								{{ `维修记录${index + 1}` }}
							</div>
						</template>
						<el-descriptions :column="3">
							<el-descriptions-item label="渠道类型">
								{{ item.vsourceTypeName }}
							</el-descriptions-item>
							<el-descriptions-item label="维修单号">
								{{ item.vrepairNo }}
							</el-descriptions-item>
							<el-descriptions-item label="创建日期">
								{{ $utils.timeFormat(item.dcreatetime) }}
							</el-descriptions-item>
							<el-descriptions-item label="维修大类">
								{{ hisRepairDetail.vrepairTypeName }}
							</el-descriptions-item>
							<el-descriptions-item label="维修小类">
								{{ hisRepairDetail.vrepairSubTypeName }}
							</el-descriptions-item>
							<el-descriptions-item label="故障类型">
								{{ hisRepairDetail.vmalfunctionTypeName }}
							</el-descriptions-item>
							<el-descriptions-item label="产品品牌">
								{{ hisRepairDetail.vproductBrand }}
							</el-descriptions-item>
							<el-descriptions-item label="产品年限">
								{{ hisRepairDetail.vproductLife }}
							</el-descriptions-item>
							<el-descriptions-item label="产品型号">
								{{ hisRepairDetail.vproductModel }}
							</el-descriptions-item>
							<el-descriptions-item label="回传维修审核结果">
								{{
									$constants.getLabel(
										"backIsOr",
										hisRepairDetail.ibackRepairAudit
									)
								}}
							</el-descriptions-item>
							<el-descriptions-item label="回传上门维修结果">
								{{
									$constants.getLabel(
										"backIsOr",
										hisRepairDetail.ibackRepairVisit
									)
								}}
							</el-descriptions-item>
							<el-descriptions-item label="回传维修服务结果">
								{{
									$constants.getLabel(
										"backIsOr",
										hisRepairDetail.ibackRepairResult
									)
								}}
							</el-descriptions-item>
							<el-descriptions-item label="维修备注">
								{{ hisRepairDetail.vremark }}
							</el-descriptions-item>
						</el-descriptions>
					</el-collapse-item>
				</el-collapse>
			</div>
			<block v-if="orderInfo.iauditStatus == '2'">
				<div class="module">
					<div class="module-title">
						<div class="el-descriptions__title">维修信息</div>
						<div
							class="el-descriptions__extra"
							v-if="orderInfo.irepairStatus == '2' && orderInfo.isCancel != '1'"
						>
							<el-button
								v-if="$init.hasPower(`/overhaul/overhaulList##WXQR`)"
								type="primary"
								size="small"
								icon="el-icon-plus"
								@click="confirmRepair"
								>维修确认</el-button
							>
						</div>
					</div>
				</div>
				<div class="module-cont">
					<div
						v-if="orderInfo.irepairStatus == '1' && orderInfo.isCancel != '1'"
					>
						<div class="nomessage">无维修信息!</div>
						<el-button
							v-if="$init.hasPower(`/overhaul/overhaulList##FPWXXX`)"
							class="addRepair"
							type="primary"
							icon="el-icon-plus"
							@click="addRepair"
						>
							录入维修信息
						</el-button>
					</div>
					<block v-else>
						<el-descriptions>
							<el-descriptions-item label="维修服务商">
								{{ allotRepairInfo.vrepairHallName }}
							</el-descriptions-item>
							<el-descriptions-item label="维修服务商电话">
								{{ allotRepairInfo.vrepairHallTelephone }}
							</el-descriptions-item>
							<el-descriptions-item label="维修服务商联系人">
								{{ allotRepairInfo.vrepairHallContact }}
							</el-descriptions-item>
							<el-descriptions-item label="维修人员姓名">
								{{ allotRepairInfo.vrepairManName }}
							</el-descriptions-item>
							<el-descriptions-item label="维修人员电话">
								{{ allotRepairInfo.vrepairManTelephone }}
							</el-descriptions-item>
							<el-descriptions-item label="工号">
								{{ allotRepairInfo.vrepairManJobNo }}
							</el-descriptions-item>
							<el-descriptions-item label="维修供应商地址">
								{{ allotRepairInfo.vrepairHallAddress }}
							</el-descriptions-item>

							<el-descriptions-item label="维修结果">
								{{
									allotRepairInfo.vrepairResult == "1"
										? "维修完成"
										: "维修未完成"
								}}
							</el-descriptions-item>
							<el-descriptions-item
								label="未完成原因"
								v-if="allotRepairInfo.vrepairResult == '2'"
							>
								{{
									$constants.getLabel(
										"reasonList",
										allotRepairInfo.vrepairFailReason
									)
								}}
							</el-descriptions-item>
							<el-descriptions-item label="维修开始时间">
								{{ $utils.timeFormat(allotRepairInfo.drepairBeginTime) }}
							</el-descriptions-item>
							<el-descriptions-item label="维修结束时间">
								{{ $utils.timeFormat(allotRepairInfo.drepairEndTime) }}
							</el-descriptions-item>
							<el-descriptions-item label="剩余维保金额">
								{{
									$utils.formatMoneyThousand({
										value: allotRepairInfo.iresidueAmount,
									})
								}}
							</el-descriptions-item>
							<el-descriptions-item label="此次维修金额">
								{{
									$utils.formatMoneyThousand({
										value: allotRepairInfo.icurrentRepairAmount,
									})
								}}
							</el-descriptions-item>
							<el-descriptions-item label="维修确认时间">
								{{ $utils.timeFormat(allotRepairInfo.drepairConfirmTime) }}
							</el-descriptions-item>
							<el-descriptions-item label="操作人">
								{{ allotRepairInfo.optUser }}
							</el-descriptions-item>
						</el-descriptions>
						<el-descriptions>
							<el-descriptions-item label="维修凭证">
								<div v-if="repairVoucherList.length > 0">
									<ul class="el-upload-list el-upload-list--picture-card">
										<li
											tabindex="0"
											class="el-upload-list__item is-ready"
											v-for="(item, index) in repairVoucherList"
											:key="index"
										>
											<el-image
												:src="`${item}`"
												alt=""
												class="el-upload-list__item-thumbnail"
												:preview-src-list="repairVoucherList"
											/>
										</li>
									</ul>
								</div>
							</el-descriptions-item>
						</el-descriptions>
						<el-descriptions>
							<el-descriptions-item label="维修备注" :span="3">
								{{ allotRepairInfo.vremark }}
							</el-descriptions-item>
						</el-descriptions>
					</block>
				</div>
			</block>
			<block>
				<div class="module">
					<div class="module-title">
						<div class="el-descriptions__title">日志信息</div>
					</div>
				</div>
				<div class="module-cont">
					<el-table
						:data="logList"
						border
						stripe
						style="width: 100%"
						:max-height="500"
					>
						<el-table-column
							width="140px"
							prop="vopreationTypeName"
							label="操作类型"
						>
						</el-table-column>
						<el-table-column prop="dopreationDate" label="操作时间">
							<template slot-scope="scope">{{
								$utils.timeFormat(scope.row.dopreationDate)
							}}</template>
						</el-table-column>
						<el-table-column prop="vopreaterName" label="操作人">
						</el-table-column>
						<el-table-column prop="vopreationResultDesc" label="操作结果">
						</el-table-column>
					</el-table>
				</div>
			</block>
			<div class="form-ctrls">
				<el-button @click="goBack">返回</el-button>
			</div>
			<serviceDialog ref="serviceDialog" @change="reload" />
			<confirmDialog ref="confirmDialog" @change="reload" />
			<trigger ref="trigger" @change="reload"></trigger>
		</Card>
	</div>
</template>

<script>
import Card from "@/components/CardForm";
import workFlow from "./components/workFlow.vue";
import serviceDialog from "./components/serviceDialog.vue";
import confirmDialog from "./components/confirmDialog.vue";
import trigger from "./components/trigger";

export default {
	name: "processDetails",
	components: {
		Card,
		workFlow,
		serviceDialog,
		confirmDialog,
		trigger,
	},
	mounted() {},
	data() {
		return {
			loading: false,
			type: this.$route.query.type,
			id: this.$route.query.id,
			orderInfo: {
				isCancel: "",
				vsourceTypeName: "",
				pkFacilityRepairOrderId: "",
				vfkPolicyInfoId: "",
				isourceType: "",
				vrepairNo: "",
				dcreatetime: "",
				vrepairType: "",
				vrepairTypeName: "",
				vrepairSubType: "",
				vrepairSubTypeName: "",
				vmalfunctionType: "",
				vmalfunctionTypeName: "",
				vproductBrand: "",
				vproductLife: "",
				vproductModel: "",
				vremark: "",
				ibackRepairAudit: "",
				ibackRepairVisit: "",
				ibackRepairResult: "",
				vcontactName: "",
				vcontactTelephone: "",
				iauditStatus: "",
				iauditStatusName: "",
				irepairStatus: "",
				irepairStatusName: "",
				vreserveVisitTime: "",
				policyCreateDate: "",
				policyEffectiveDate: "",
				policyEndDate: "",
				visitRepairAddress: "",
			}, // 基础信息
			malFunctionImages: [],
			certificateUrls: [],
			productInfo: {
				vfkPolicyInfoId: "",
				proName: "",
				guaLimt: "",
				instSummary: "",
			}, // 产品信息
			flowNodeList: [], // 流程节点列表
			hisRepairList: [], // hisRepairList
			hisRepairDetail: {
				vsourceTypeName: "",
				pkFacilityRepairOrderId: "",
				vfkPolicyInfoId: "",
				isourceType: "",
				vrepairNo: "",
				dcreatetime: "",
				vrepairType: "",
				vrepairTypeName: "",
				vrepairSubType: "",
				vrepairSubTypeName: "",
				vmalfunctionType: "",
				vmalfunctionTypeName: "",
				vproductBrand: "",
				vproductLife: "",
				vproductModel: "",
				vremark: "",
				ibackRepairAudit: "",
				ibackRepairVisit: "",
				ibackRepairResult: "",
				vcontactName: "",
				vcontactTelephone: "",
				iauditStatus: "",
				iauditStatusName: "",
				irepairStatus: "",
				irepairStatusName: "",
			},
			allotRepairInfo: {
				dcreatetime: "",
				drepairBeginTime: "",
				drepairEndTime: "",
				fkFacilityRepairOrderId: "",
				vremark: "",
				vrepairFailReason: "",
				vrepairHallAddress: "",
				vrepairHallContact: "",
				vrepairHallName: "",
				vrepairHallTelephone: "",
				vrepairManJobNo: "",
				vrepairManName: "",
				vrepairManTelephone: "",
				vrepairResult: "",
				optUser: "",
				drepairConfirmTime: "",
				icurrentRepairAmount: "",
				iresidueAmount: "",
			}, // 分配信息
			repairVoucherList: [], // 维修凭证列表
			logList: [], // 日志列表
			// 验证信息
			rules: {},
		};
	},
	created() {
		this.getInfo();
	},
	mounted() {
		this.getFlowNodeList();
		this.getHisRepairList();
		this.getLogList();
	},
	methods: {
		/**
		 * 返回
		 */
		goBack() {
			this.$store.commit("backTab");
		},

		/**
		 * 审核
		 */
		openTrigger(obj) {
			this.$refs.trigger.dialogFormVisible = true;
			this.$refs.trigger.initData(this.id);
		},
		// replace() {
		// 	this.$router.replace(`/overhaul/overhaulDetail?type=view&id=${this.id}`);
		// },
		/**
		 * 获取详情
		 */
		getInfo() {
			if (!this.id) {
				return;
			}
			const vm = this;
			let postData = {
				pkFacilityRepairOrderId: this.id,
			};
			this.$http
				.get(`/facilityRepairOrder/getFacilityRepairOrderInfo`, postData)
				.then(function (response) {
					if (response.data.header.code == "A1000") {
						let orderInfo = response.data.body.facilityRepairOrderInfo;
						let productInfo = response.data.body.channelProductInfo;
						vm.certificateUrls = response.data.body.repairVoucherList || [];
						let malFunctionImages = response.data.body.malFunctionImages || [];

						vm.malFunctionImages = malFunctionImages.map(
							(item) => `https://applyimage.hollardchina.com.cn/${item}`
						);
						for (const key in vm.orderInfo) {
							vm.orderInfo[key] = orderInfo[key];
						}
						console.log(vm.orderInfo, "vm.orderInfo");

						for (const key in vm.productInfo) {
							vm.productInfo[key] = productInfo[key];
						}
						if (vm.orderInfo.iauditStatus == "2") {
							vm.getAllotRepairOrder();
						}
					} else {
						vm.$message.warning(response.data.header.msg);
					}
				})
				.catch(function (error) {
					console.log(error);
					// vm.$message.error("网络错误");
				});
		},

		// 获取分配的维修信息
		getAllotRepairOrder() {
			const vm = this;
			let postData = {
				repairOrderId: this.id,
			};
			this.$http
				.post(`/facilityRepairOrder/getAllotRepairOrder`, postData)
				.then(function (response) {
					if (response.data.header.code == "A1000") {
						let data = response.data.body.getAllotRepairOrderDTO || {};
						let list = response.data.body.repairVoucherList || [];
						for (const key in vm.allotRepairInfo) {
							vm.allotRepairInfo[key] = data[key];
						}
						vm.repairVoucherList = list.map(
							(item) => `https://aires.hollardchina.com.cn/${item}`
						);
					} else {
						vm.$message.warning(response.data.header.msg);
					}
				})
				.catch(function (error) {
					vm.$message.error("网络错误");
				});
		},

		// 确认维修
		confirmRepair() {
			this.$refs.confirmDialog.dialogFormVisible = true;
			this.$refs.confirmDialog.initData(
				this.allotRepairInfo.fkFacilityRepairOrderId
			);
		},

		// 获取操作日志
		getLogList() {
			if (!this.id) {
				return;
			}
			const vm = this;
			let postData = {
				pkFacilityRepairOrderId: this.id,
			};
			this.$http
				.get(`/facilityRepairOrder/getLogFacilityRepairList`, postData)
				.then(function (response) {
					if (response.data.header.code == "A1000") {
						vm.logList = response.data.body.list;
					} else {
						vm.$message.warning(response.data.header.msg);
					}
				})
				.catch(function (error) {
					vm.$message.error("网络错误");
				});
		},

		//获取维修工单流程节点列表
		getFlowNodeList() {
			if (!this.id) {
				return;
			}
			const vm = this;
			let postData = {
				repairOrderId: this.id,
			};
			this.$http
				.get(`/facilityRepairOrder/getRepairFlowList`, postData)
				.then(function (response) {
					if (response.data.header.code == "A1000") {
						vm.flowNodeList = response.data.body.flowNodeList;
					} else {
						vm.$message.warning(response.data.header.msg);
					}
				})
				.catch(function (error) {
					vm.$message.error("网络错误");
				});
		},

		//维修单单详细-获取历史维修列表
		getHisRepairList() {
			if (!this.id) {
				return;
			}
			const vm = this;
			let postData = {
				currOrderId: this.id,
			};
			this.$http
				.get(`/facilityRepairOrder/getHisRepairOrderList`, postData)
				.then(function (response) {
					if (response.data.header.code == "A1000") {
						vm.hisRepairList = response.data.body.list;
					} else {
						vm.$message.warning(response.data.header.msg);
					}
				})
				.catch(function (error) {
					vm.$message.error("网络错误");
				});
		},

		handleCollapseChange(activeNames) {
			const vm = this;
			if (activeNames) {
				let postData = {
					pkFacilityRepairOrderId: activeNames,
				};
				this.$http
					.get(`/facilityRepairOrder/getFacilityRepairOrderInfo`, postData)
					.then(function (response) {
						if (response.data.header.code == "A1000") {
							vm.hisRepairDetail = response.data.body.facilityRepairOrderInfo;
						} else {
							vm.$message.warning(response.data.header.msg);
						}
					})
					.catch(function (error) {
						vm.$message.error("网络错误");
					});
			} else {
				for (const key in vm.hisRepairDetail) {
					vm.hisRepairDetail[key] = "";
				}
			}
		},

		// 录入维修记录
		addRepair() {
			this.$refs.serviceDialog.dialogFormVisible = true;
			this.$refs.serviceDialog.initData(this.id);
		},
		/**
		 * 审核
		 */
		openTrigger() {
			this.$refs.trigger.dialogFormVisible = true;
			this.$refs.trigger.initData(this.id);
		},

		reload() {
			this.getInfo();
			this.getLogList();
			this.getFlowNodeList();
			this.getHisRepairList();
		},
	},
	computed: {
		/**
		 * 卡模块参数
		 */
		cardInfo() {
			if (this.type == "add") {
				return {
					icon: "el-icon-document-add",
					name: "新增维修单",
				};
			} else if (this.type == "edit") {
				return {
					icon: "el-icon-edit-outline",
					name: "修改维修单",
				};
			}
			return {
				icon: "el-icon-document",
				name: "维修单详情",
			};
		},
	},
};
</script>

<style lang="scss" scoped>
.detail-cont {
	.noCardHeader {
		max-width: 980% !important;
	}

	::v-deep .card-header {
		display: none !important;
	}

	::v-deep .el-collapse {
		border: none;
	}
	::v-deep .el-collapse-item:last-child {
		.el-collapse-item__header {
			border-bottom: none !important;
		}
	}
	::v-deep .el-descriptions-item__label {
		font-weight: 700;
		color: #333;
		width: 120px;
		text-align: right;
		display: block;
	}
	::v-deep .el-descriptions-item__cell {
		// padding-bottom: 0 !important;
		padding-bottom: 20px !important;
	}
}

.descriptions-div {
	font-size: 14px;
	font-weight: 700;
	// ::v-deep .el-descriptions-item__cell {
	// 	padding-bottom: 0 !important;
	// }
}

.module {
	border-bottom: 1px solid #eee;
	margin-bottom: 16px;
	.module-title {
		display: flex;
		justify-content: space-between;
		padding: 4px 10px;
		border-left: 4px solid #409eff;
		margin-bottom: 8px;
	}
}
.module-cont {
	margin-bottom: 20px;
}
.flex-row {
	display: flex;
	justify-content: space-between;
	align-items: center;
}
.nomessage {
	text-align: center;
}
.addRepair {
	display: block;
	margin: 6px auto 0;
}
.description {
	display: flex;
}
</style>
